import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function BrowserIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 50 42">
      <path fill="currentColor" fillRule="evenodd" d="M46.667 0C48.5 0 50 1.512 50 3.36v35.28c0 1.848-1.5 3.36-3.333 3.36H3.333C1.5 42 0 40.488 0 38.64V3.36C0 1.512 1.5 0 3.333 0h43.334zm-19.06 34.846l-3.129-7.078-4.329 4.663.114-18.931 14.065 12.865-6.322-.169 3.19 7.134c.398.955-.058 2.135-1.026 2.528-.967.393-2.106-.057-2.562-1.012zm20.17 4.383V9.606H2.223V38.64c0 .617.5 1.12 1.111 1.12h43.334c.612 0 1.11.086 1.11-.53zm0-31.666V3.36c0-.617-.498-1.12-1.11-1.12H3.333c-.612 0-1.11.503-1.11 1.12v4.202h45.555zM12.314 3.75c.641 0 1.12.483 1.12 1.125 0 .644-.48 1.125-1.12 1.125-.64 0-1.119-.483-1.119-1.125 0-.644.48-1.125 1.12-1.125zm-7.462 0c.639 0 1.117.483 1.12 1.125A1.1 1.1 0 014.85 6a1.13 1.13 0 01-1.12-1.125c0-.644.481-1.125 1.12-1.125zm3.731 0c.639 0 1.117.483 1.12 1.125C9.701 5.519 9.22 6 8.581 6c-.64 0-1.12-.483-1.12-1.125 0-.644.481-1.125 1.12-1.125z"/>
    </SvgIcon>
  )
}
export default BrowserIcon
